'use strict';

exports.__esModule = true;

var _emotion = require('emotion');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHighlightWords = require('react-highlight-words');

var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);

var _reactEmotion = require('react-emotion');

var _Flex = require('../../../styles/Flex');

var _Flex2 = _interopRequireDefault(_Flex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var highlightStyle = {
	fontWeight: 600,
	padding: 0,
	backgroundColor: 'transparent',
	color: 'inherit'
};

var SuggestionItem = function SuggestionItem(_ref) {
	var currentValue = _ref.currentValue,
	    suggestion = _ref.suggestion;
	var label = suggestion.label,
	    value = suggestion.value,
	    title = suggestion.title,
	    description = suggestion.description,
	    image = suggestion.image;

	if (label) {
		// label has highest precedence
		return typeof label === 'string' ? _react2.default.createElement(
			'div',
			{ className: 'trim' },
			_react2.default.createElement(_reactHighlightWords2.default, {
				searchWords: currentValue.split(' '),
				textToHighlight: label,
				autoEscape: true,
				highlightStyle: highlightStyle
			})
		) : label;
	} else if (title || image || description) {
		return _react2.default.createElement(
			_Flex2.default,
			{ alignItems: 'center', className: (0, _emotion.css)({ width: '100%' })
			},
			image && _react2.default.createElement(
				'div',
				{
					className: (0, _emotion.css)({ margin: 'auto', marginRight: 10 })
				},
				_react2.default.createElement('img', {
					src: image,
					alt: ' ',
					height: '50px',
					width: '50px',
					className: (0, _emotion.css)({ objectFit: 'contain' })
				})
			),
			_react2.default.createElement(
				_Flex2.default,
				{ direction: 'column', className: (0, _emotion.css)({ width: image ? 'calc(100% - 60px)' : '100%' })
				},
				title && _react2.default.createElement(
					'div',
					{ className: 'trim' },
					_react2.default.createElement(_reactHighlightWords2.default, {
						searchWords: currentValue.split(' '),
						textToHighlight: title,
						highlightStyle: highlightStyle,
						className: /*#__PURE__*/ /*#__PURE__*/(0, _reactEmotion.css)({ fontSize: '1rem' })
					})
				),
				description && _react2.default.createElement(
					'div',
					{ className: (0, _reactEmotion.cx)('trim', /*#__PURE__*/(0, _reactEmotion.css)({ marginTop: 3 })) },
					_react2.default.createElement(_reactHighlightWords2.default, {
						searchWords: currentValue.split(' '),
						textToHighlight: description,
						highlightStyle: highlightStyle
					})
				)
			)
		);
	}
	return value;
};

exports.default = SuggestionItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appbaseio/reactivesearch/lib/components/search/addons/SuggestionItem.js
// module id = ./node_modules/@appbaseio/reactivesearch/lib/components/search/addons/SuggestionItem.js
// module chunks = 0